<template>
  <td v-html="percent"></td>
</template>

<script lang="babel">
export default {
  props: {
    content: {
      required: true,
      type: Number
    }
  },
  computed: {
    percent() {
      return ((this.content / 5) * 100).toFixed(2) + '%';
    }
  }
};
</script>
